module.exports = __webpack_public_path__ + "img/professionalAfter-salesServiceTeam.2dcd7ff2.svg";